export enum ImportState {
  IMPORT_CREATED = 'CREATED',
  IMPORT_IN_PROGRESS = 'IN_PROGRESS',
  IMPORT_SUCCEEDED = 'SUCCEEDED',
  IMPORT_FAILED = 'FAILED'
}
